import {AuthToken, type AuthTokenResult} from './auth-token'
import {CopilotAuthTokenProvider} from './copilot-auth-token'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export const AGENT_SESSIONS_TOKEN_KEY = 'AGENT_SESSIONS_TOKEN'

export class AgentSessionsTokenProvider extends CopilotAuthTokenProvider {
  constructor() {
    const tokenEndpoint = `/copilot/agent-sessions/token`
    super([], tokenEndpoint, AGENT_SESSIONS_TOKEN_KEY)
  }

  protected override async validateAuthToken(token: AuthToken): Promise<AuthToken> {
    if (token.ssoChanged(this.ssoOrgIDs)) {
      return this.fetchAuthToken()
    }

    if (!token.isExpired) {
      return token
    }

    if (token.refreshToken) {
      try {
        return await this.#fetchAuthTokenWithRefresh(token.refreshToken)
      } catch {
        // Fall through to mint new token
      }
    }

    return this.fetchAuthToken()
  }

  async #fetchAuthTokenWithRefresh(refreshToken: string): Promise<AuthToken> {
    const response = await verifiedFetchJSON(this.tokenEndpoint, {
      method: 'POST',
      body: JSON.stringify({refresh_token: refreshToken}),
    })

    if (!response.ok) {
      throw new Error(`Failed to refresh token: ${response.status}`)
    }

    const result = (await response.json()) as AuthTokenResult
    const newToken = AuthToken.fromResult(result, this.ssoOrgIDs)
    this.ssoOrgIDs = newToken.ssoOrgIDs
    this.setLocalStorageAuthToken(newToken)

    return newToken
  }
}
